import { Omit } from '@40seas/entities/common';
import { BaseEntityFieldsArray } from '@40seas/models';
import { Billing } from './billing.entity';

export class CreateBillingDto extends Omit(Billing, [...BaseEntityFieldsArray, 'status']) {}
